import { BACKEND_URL } from '../firebase/config';

const driveFileIdPatterns = [
  /drive:\/\/([^/?#]+)/,
  /\/api\/upload\/file\/([^/?#]+)/,
  /drive\.google\.com\/file\/d\/([^/?#]+)/,
  /drive\.google\.com\/open\?id=([^&#]+)/,
  /drive\.google\.com\/uc\?(?:[^#]*&)?id=([^&#]+)/
];

const apiFileUrl = (fileId) => `${BACKEND_URL.replace(/\/$/, '')}/api/upload/file/${encodeURIComponent(fileId)}`;
const latestStudentPhotoUrl = (rollNumber) => `${BACKEND_URL.replace(/\/$/, '')}/api/upload/latest-photo/${encodeURIComponent(rollNumber)}`;
const isBundledUploadPath = (value) => /^\/?uploads\//.test(value || '');

export const getDisplayFileUrl = (value) => {
  if (!value || typeof value !== 'string') return '';

  const trimmed = value.trim();
  const match = driveFileIdPatterns
    .map((pattern) => trimmed.match(pattern))
    .find(Boolean);

  if (match?.[1]) {
    return apiFileUrl(decodeURIComponent(match[1]));
  }

  return trimmed;
};

export const getStudentPhotoUrl = (student) => {
  const storedUrl = getDisplayFileUrl(student?.photoPath || student?.photoUrl || '');
  const rollNumber = student?.rollNumber;
  const useDrivePhotoLookup = process.env.REACT_APP_STORAGE_MODE === 'drive' && rollNumber;

  if (storedUrl && (!useDrivePhotoLookup || !isBundledUploadPath(storedUrl))) {
    return storedUrl;
  }

  if (useDrivePhotoLookup) {
    return latestStudentPhotoUrl(rollNumber);
  }

  return storedUrl;
};
